import Client from '../axiosClient'
const resource = '/prospect';
const resourceInit = 'prospect-init/bootstrap';
const resourceEmail = 'prospect-init/send-email';
const resourceStatus = 'prospect-init/change-status';
const resourceConfirmCode = 'prospect-init/confirm-code';
const resourceViewHistory ='prospect-init/view-history'
const resourceInitTemplate = 'prospect-temp-init/bootstrap';
const resourceConfirmCodeTemplate = 'prospect-temp-init/confirm-code';
const resourceStatusTemplate = 'prospect-temp-init/change-status';

const resourceTemplate = '/prospect-template';

export default {

  init() {
    return Client.get(`${resourceInit}`);
  },


  getList(payload=[]) {
   
    return Client.get(`${resource}?filters=`+JSON.stringify(payload));

  },
  post(payload) {
    return Client.post(`${resource}`,payload);
  },
  changeStatus (payload) {
    return Client.post(`${resourceStatus}`,payload);
  },
  sendEmail(payload) {
    return Client.post(`${resourceEmail}`,payload);
  },
  confirmCode(payload) {
    return Client.post(`${resourceConfirmCode}`,payload);
  },
  viewHistory(payload) {
    return Client.post(`${resourceViewHistory}`,payload);
  },
  

  initTemplate() {
    return Client.get(`${resourceInitTemplate}`);
  },
  postTemplate(payload) {
    return Client.post(`${resourceTemplate}`,payload);
  },
  getListTemplate(payload=[]) {   
    return Client.get(`${resourceTemplate}?filters=`+JSON.stringify(payload));
  },
  confirmCodeTemplate(payload) {
    return Client.post(`${resourceConfirmCodeTemplate}`,payload);
  },

  changeStatusTemplate (payload) {
    return Client.post(`${resourceStatusTemplate}`,payload);
  },
  // MANY OTHER ENDPOINT RELATED STUFFS
};



// WEBPACK FOOTER //
// ./src/repositories/business/Prospect.js